/// <amd-module name="SearchUI/Components/WikiSearchResultComponent/index" />
export * from "SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem";
export * from "SearchUI/Components/WikiSearchResultComponent/WikiSearchResultItem.Props";
